import * as React from 'react';
import './MultipleSelection.css';

export interface IOptArray {
    optId: string;
    optName: string;
    optColor?: string;
}
interface IMultipleSelectionProps {
    optArray: IOptArray[];
    selectedArray: string[];
    selectCallback: (optId: string) => void;
}
interface IMultipleSelectionState {
    menuOpen: boolean;
}

class MultipleSelection extends React.Component<IMultipleSelectionProps, IMultipleSelectionState> {
    constructor(props: IMultipleSelectionProps) {
        super(props);

        this.state = {
            menuOpen: false
        };
    }

    render() {
        let firstSelected = '';
        if (this.props.selectedArray.length > 0 && this.props.optArray.length > 0) {
            let temp = this.props.optArray.find((elem) => {
                return elem.optId === this.props.selectedArray[0] ? true : false;
            });
            if (temp !== undefined) {
                firstSelected = temp.optName;
            }
        }

        return (
            <div className={'multipleSelection'}>
                <div className={'multipleSelection__header'}></div>
                <div
                    className={'multipleSelection__main'}
                    tabIndex={1}
                    onBlur={(event) => {
                        this.setState({ menuOpen: false });
                    }}>
                    <div className={'multipleSelection__main__menu'}>
                        <div className={'multipleSelection__main__menu__person'}>
                            <p
                                style={{
                                    textOverflow: 'ellipsis',
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                    marginBottom: 0
                                }}>
                                {firstSelected}
                            </p>
                        </div>
                        <div
                            className={'multipleSelection__main__menu__arrow'}
                            style={this.state.menuOpen ? { transform: 'rotate(-90deg)' } : {}}
                            onClick={() => {
                                this.setState({ menuOpen: !this.state.menuOpen });
                            }}>
                            {'>'}
                        </div>
                    </div>
                    <div
                        className={
                            this.state.menuOpen
                                ? 'multipleSelection__main__menuClose multipleSelection__main__menu--open'
                                : 'multipleSelection__main__menuClose'
                        }>
                        {this.props.optArray.map((opt, index) => {
                            let css = 'multipleSelection__main__menu__person ';
                            if (
                                this.props.selectedArray.findIndex((elem) => {
                                    return elem === opt.optId ? true : false;
                                }) >= 0
                            ) {
                                css =
                                    'multipleSelection__main__menu__person  multipleSelection__main__menu__person--selected';
                            }
                            return (
                                <div
                                    className={css}
                                    style={{ display: 'flex', alignItems: 'center' }}
                                    key={index}
                                    onClick={() => {
                                        this.props.selectCallback(opt.optId);
                                    }}>
                                    {opt.optColor !== undefined && (
                                        <div
                                            style={{
                                                backgroundColor: opt.optColor,
                                                height: '1.6em',
                                                width: '1.6em',
                                                borderRadius: '0.8em',
                                                textAlign: 'center',
                                                margin: '0.4em'
                                            }}>
                                            {opt.optName[0]}
                                        </div>
                                    )}
                                    <text
                                        style={{
                                            textOverflow: 'ellipsis',
                                            overflow: 'hidden',
                                            whiteSpace: 'nowrap'
                                        }}>
                                        {opt.optName}
                                    </text>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    }
}

export default MultipleSelection;
